import React from 'react';

import {MainBlockContainer} from './styles';

import MainHeaderContainer from './MainHeader';
import MainContent from './MainContent';

const MainBlock = ({
  showRecords,
  showPoll,
  showRules,
  show_logo,
  isRulesShown,
  hideRules,
  showOferta,
  isOfertaShown,
  hideOferta,
  balance,
  handleMouseMove,
  isSocialPoll,
  isPollShown,
  isRecordsShown,
  setSelectedGames,
  selectedGames,
  gameMenu,
  isChangeHotkeyShown,
  isAccountShown,
  isTeoryShown,
  showAccount,
  hideAccount,
  showTeory,
  hideTeory,
}) => {
  return (
    <MainBlockContainer>
      <MainHeaderContainer
        showRules={showRules}
        show_logo={show_logo}
        balance={balance}
        isRulesShown={isRulesShown}
        hideRules={hideRules}
        showOferta={showOferta}
        isOfertaShown={isOfertaShown}
        hideOferta={hideOferta}
        showRecords={showRecords}
        showPoll={showPoll}
        isSocialPoll={isSocialPoll}
        showAccount={showAccount}
        hideAccount={hideAccount}
        showTeory={showTeory}
        hideTeory={hideTeory}
      />
      <MainContent
      handleMouseMove={handleMouseMove}
      isSocialPoll={isSocialPoll}
      isRulesShown={isRulesShown}
      isOfertaShown={isOfertaShown}
      isPollShown={isPollShown}
      isRecordsShown={isRecordsShown}
      showPoll={showPoll}
      showRecords={showRecords}
      gameMenu={gameMenu}
      setSelectedGames={setSelectedGames}
      selectedGames={selectedGames}
      isChangeHotkeyShown={isChangeHotkeyShown}
      isAccountShown={isAccountShown}
      isTeoryShown={isTeoryShown}
      showAccount={showAccount}
      hideAccount={hideAccount}
      showTeory={showTeory}
      hideTeory={hideTeory}
      />
    </MainBlockContainer>
  );
};

export default MainBlock;
